import { Card, CardContent } from '@/components/ui/card';
import { Users, Scale, Shield, FileText, Award, AlertTriangle } from 'lucide-react';

const committees = [
  {
    icon: Users,
    title: 'Board of Directors',
    desc: 'Provides strategic leadership and overall governance oversight for IMCAC operations, ensuring alignment with the organisation\'s mission and international certification standards.',
    members: 'Composition details to be announced',
  },
  {
    icon: FileText,
    title: 'Examination Committee',
    desc: 'Oversees the development, administration, and quality assurance of all competency-based examinations. Ensures examination content reflects current clinical practice and professional standards.',
    members: 'Composition details to be announced',
  },
  {
    icon: Scale,
    title: 'Ethics Committee',
    desc: 'Reviews ethical matters related to certification, examination conduct, and professional behaviour. Investigates complaints and ensures adherence to IMCAC\'s Code of Ethics.',
    members: 'Composition details to be announced',
  },
  {
    icon: AlertTriangle,
    title: 'Appeals Committee',
    desc: 'Provides an independent review process for candidates who wish to appeal examination results, certification decisions, or disciplinary actions.',
    members: 'Composition details to be announced',
  },
  {
    icon: Award,
    title: 'Certification Committee',
    desc: 'Makes final decisions on certification eligibility, certification maintenance, and recertification requirements. Ensures certification standards remain rigorous and relevant.',
    members: 'Composition details to be announced',
  },
  {
    icon: Shield,
    title: 'Standard Setting Committee',
    desc: 'Establishes and reviews competency standards, pass/fail criteria, and assessment benchmarks. Ensures alignment with international best practices in professional certification.',
    members: 'Composition details to be announced',
  },
];

export default function GovernanceStructurePage() {
  return (
    <div data-testid="governance-structure-page">
      <section className="bg-[#1B2A4A] py-16 md:py-20">
        <div className="imcac-container">
          <p className="imcac-overline mb-3">Organisational Governance</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight font-heading">Governance Structure</h1>
          <div className="h-1 w-20 bg-[#C5A572] mt-5" />
          <p className="text-lg text-slate-300 mt-4 max-w-3xl">
            IMCAC operates under a transparent governance framework with clearly defined committees responsible for examination integrity, ethical oversight, and certification standards.
          </p>
        </div>
      </section>

      <section className="imcac-section bg-white">
        <div className="imcac-container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {committees.map((committee, i) => (
              <Card key={i} className="imcac-card border-t-2 border-t-[#C5A572]" data-testid={`committee-${i}`}>
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-[#1B2A4A] rounded-sm flex items-center justify-center mb-4">
                    <committee.icon className="h-6 w-6 text-[#C5A572]" />
                  </div>
                  <h3 className="text-lg font-semibold text-[#1B2A4A] font-heading mb-3">{committee.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed mb-4">{committee.desc}</p>
                  <p className="text-xs text-slate-400 italic">{committee.members}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="imcac-section bg-[#F8FAFC]">
        <div className="imcac-container">
          <div className="bg-white border border-slate-200 rounded-sm p-6 md:p-8">
            <div className="flex items-start gap-4">
              <Shield className="h-6 w-6 text-[#C5A572] flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="text-base font-semibold text-[#1B2A4A] font-heading mb-2">Governance Principles</h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  All governance committees operate with full independence from educational providers, training organisations, and commercial entities. Committee members are bound by conflict of interest policies, confidentiality agreements, and the IMCAC Code of Ethics. Decisions related to examinations, certification, and standards are made solely on the basis of professional competency criteria.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
